var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinM = function SvgCoinM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.805 10.796H2v5.899a3.804 3.804 0 0 0 3.805 3.804zM15.899 9.824l-1.483 1.482-1.482-1.482 1.482-1.483z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.593 16.125a4.375 4.375 0 0 1-4.376 4.375H7.241V3h14.352zM10.947 15.05v1.875h6.939v-1.875zm3.47-8.694a3.47 3.47 0 1 0 0 6.938 3.47 3.47 0 0 0 0-6.938",
    clipRule: "evenodd"
  })));
};
export default SvgCoinM;